import { createContext, useEffect, useState } from "react";
import { ContextMenu } from "../components/ContextMenu/ContextMenu";

const ContextMenuContext = createContext();

const ContextMenuProvider = ({ children }) => {
	const [anchorPosition, setAnchorPosition] = useState(null);
	const [elementContext, setElementContext] = useState({ type: '', data: '', availableOptions: [] });
	// const [availableOptions, setAvailableOptions] = useState([]);
	const [contextHtmlElement, setContextHtmlElement] = useState(null);
	const [styleBackup, setStyleBackup] = useState('');
	let disabled = false;


	const closeMenu = () => {
		contextHtmlElement?.setAttribute('style', styleBackup);
		setElementContext({ type: '', data: '', availableOptions: [] });
		setAnchorPosition(null);
		// setAvailableOptions([]);
	}

	const openMenu = (event) => {
		if (event.contextMenuInfo) {
			let { type, data, highlightstyle, options, target } = event.contextMenuInfo;
			event.preventDefault();
			// if (highlightstyle) {
			let previousStyle = target?.getAttribute('style');
			setStyleBackup(previousStyle ?? '')
			target?.setAttribute('style', `${previousStyle ?? ''} ${highlightstyle ?? ''}; cursor: progress;`);
			// }
			setElementContext({ type, data, availableOptions: options });
			setContextHtmlElement(target);
			setAnchorPosition({ left: event.clientX, top: event.clientY });
		}
	}

	// const executeAction = (actionKey) => options?.[actionKey]?.callback(elementContext.data);

	return (<ContextMenuContext.Provider value={{ closeMenu, elementContext, anchorPosition }}>
		<div onContextMenu={!disabled ? openMenu : () => { }}>
			{children}
		</div>
	</ContextMenuContext.Provider>)
}

export { ContextMenuProvider, ContextMenuContext };